import React from 'react'
import { cx } from '@emotion/css'

import { SkeletonCard, SkeletonIcon, SkeletonText, SpookySkeleton } from '@offerzen/pinata'

import styles from './styles'

const SkeletonSection = ({ titleWidth, className, children }) => (
  <SpookySkeleton>
    <SkeletonCard className={styles.card}>
      <div className={styles.header}>
        <SkeletonIcon theme="dark" className={styles.check} />
        <SkeletonText theme="dark" width={titleWidth} />
        <SkeletonIcon theme="dark" />
      </div>

      <div className={cx(styles.body, className)}>{children}</div>
    </SkeletonCard>
  </SpookySkeleton>
)

SkeletonSection.defaultProps = {
  titleWidth: 200,
}

export default SkeletonSection
